import {Controller} from "stimulus";

// Copies a social media post's saved text so the staffer can paste it
// into a network's share dialog. When the Clipboard API is missing or
// refused (plain HTTP, denied permission) it selects the text instead,
// so it can still be copied from the keyboard.
export default class extends Controller {
    static targets = ["source", "status"];

    copy() {
        if (!navigator.clipboard || !navigator.clipboard.writeText) {
            this.selectForManualCopy();
            return;
        }

        navigator.clipboard.writeText(this.sourceTarget.value)
            .then(() => this.announce("Copied"))
            .catch(() => this.selectForManualCopy());
    }

    selectForManualCopy() {
        this.sourceTarget.focus();
        this.sourceTarget.select();
        this.announce("Text selected. Press Ctrl+C (⌘C on a Mac) to copy.");
    }

    announce(message) {
        if (this.hasStatusTarget) this.statusTarget.textContent = message;
    }
}
